<template>
  <div class="form-item-box">
    <label class="form-item-label" :class="errorMessage && `form-label-error`">
      {{ label }}
    </label>
    <input v-if="number" class="form-item-input" :class="errorMessage && `form-input-error`"
      type="text" :disabled="disabled" :placeholder="placeholder" :value="formatted"
      @keyup="updateNumberValue"/>
    <input v-else class="form-item-input" :accept="acceptFileType" :class="errorMessage && `form-input-error`"
      :type="type || 'text'" :disabled="disabled" :placeholder="placeholder" :value="modelValue"
      @change="updateModelValue"/>
    <p class="form-error-text" v-if="errorMessage">{{ errorMessage }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BInput",
  props: {
    modelValue: { type: [String, Number], default: "" },
    label: { type: String, required: true },
    placeholder: String,
    type: String,
    step: String,
    errorMessage: String,
    disabled: { type: Boolean, default: false },
    number: { type: Boolean, default: false },
    acceptFileType: { type: String, default: null }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      formatted: null
    }
  },
  mounted() {
    this.formatted = this.formatNumber(this.modelValue)
  },
  computed: {
  },
  methods: {
    formatNumber(num) {
      if (typeof num == 'number') {
        const newNum = num.toLocaleString('vi-VN')
        if (newNum === 'NaN') {
          return '';
        }
        return newNum
      }
        return '';
    },
    updateModelValue(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    updateNumberValue(event) {
      const value = Number(event.target.value.replaceAll('.', ''));
      this.formatted = this.formatNumber(value)
      this.$emit('update:modelValue', value);
    }
  },
});
</script>
